import dayjs from 'dayjs'
import { Notification } from '@vae/server/dist/client'
import { NotificationGroups } from '../types/types'

export const groupNotificationsByAge = (notifications: Notification[]): NotificationGroups => {
	const today: Notification[] = []
	const yesterday: Notification[] = []
	const thisWeek: Notification[] = []
	const lastWeek: Notification[] = []
	const lastMonth: Notification[] = []
	const earlier: Notification[] = []

	const todayDate = dayjs().startOf('day')
	for (const notification of notifications) {
		const notificationDate = dayjs(notification.time).startOf('day')
		const diffDays = todayDate.diff(notificationDate, 'day')

		if (diffDays === 0) {
			today.push(notification)
		} else if (diffDays === 1) {
			yesterday.push(notification)
		} else if (notificationDate.isAfter(todayDate.startOf('week').subtract(1, 'day'))) {
			thisWeek.push(notification)
		} else if (notificationDate.isAfter(todayDate.startOf('week').subtract(1, 'week'))) {
			lastWeek.push(notification)
		} else if (notificationDate.isAfter(todayDate.startOf('month').subtract(1, 'month'))) {
			lastMonth.push(notification)
		} else {
			earlier.push(notification)
		}
	}

	return { today, yesterday, thisWeek, lastWeek, lastMonth, earlier }
}
